import { ref } from 'vue'
import { apiFetch } from '../../../utils/api'
import { isMainCompanyScope } from './monthlyConfigurationScope.js'

const searchResults = ref([])
const isSearchingUsers = ref(false)
let searchTimer = null
let searchRequestId = 0

function hasSearchScope(selectedBranchId) {
  const id = String(selectedBranchId || '').trim()
  return id !== ''
}

export function useMonthlyConfigurationUserSearch() {
  function clearUserSearchResults() {
    if (searchTimer) {
      clearTimeout(searchTimer)
      searchTimer = null
    }
    searchResults.value = []
    isSearchingUsers.value = false
  }

  function scheduleUserSearch(query, selectedBranchId) {
    if (searchTimer) {
      clearTimeout(searchTimer)
      searchTimer = null
    }

    const q = String(query || '').trim()
    if (!q || !hasSearchScope(selectedBranchId)) {
      clearUserSearchResults()
      return
    }

    searchTimer = window.setTimeout(() => {
      searchTimer = null
      runUserSearchImmediately(q, selectedBranchId)
    }, 350)
  }

  return {
    searchResults,
    isSearchingUsers,
    scheduleUserSearch,
    clearUserSearchResults
  }
}

export async function runUserSearchImmediately(query, selectedBranchId) {
  const q = String(query || '').trim()
  if (!q || !hasSearchScope(selectedBranchId)) {
    searchResults.value = []
    isSearchingUsers.value = false
    return
  }

  const requestId = ++searchRequestId
  isSearchingUsers.value = true

  try {
    const params = new URLSearchParams()
    params.set('q', q)

    const url = isMainCompanyScope(selectedBranchId)
      ? `/users/monthly-configuration/search-by-name-company?${params.toString()}`
      : (() => {
          params.set('branchId', String(selectedBranchId).trim())
          return `/users/monthly-configuration/search-by-name?${params.toString()}`
        })()

    const res = await apiFetch(url, { method: 'GET' })
    if (requestId !== searchRequestId) return

    if (!res.ok) {
      searchResults.value = []
      return
    }

    const data = await res.json().catch(() => [])
    searchResults.value = Array.isArray(data) ? data : []
  } catch {
    if (requestId !== searchRequestId) return
    searchResults.value = []
  } finally {
    if (requestId === searchRequestId) {
      isSearchingUsers.value = false
    }
  }
}
